<template>
  <a-modal
    title='修改用户'
    :width='640'
    :visible='visible'
    :confirmLoading='confirmLoading'
    @cancel='handleCancel'
  >
    <a-spin :spinning='confirmLoading'>
      <a-form :form='form'>
        <a-form-item
          v-show='false'
          label='id'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-input
            v-decorator="['id']"
            :disabled='editable || showable'
          />
        </a-form-item>
        <a-form-item
          label='姓名'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-input
            v-decorator="['name', {rules: [{required: true, message: '请输入姓名'},{max: 10,message: '最大不能超过10！'},{validator: isName}]}]" />
        </a-form-item>
        <a-form-item
          label='性别'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-select
            v-decorator="[
              'gender',
              {rules: [{ required: true, message: '请选择性别！' }]}
            ]"
            placeholder='性别'
            :options='genderList'
          />
        </a-form-item>
        <a-form-item
          label='身份证'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-input
            v-decorator="[
              'idCard',
              {rules: [{required: true,message: '请输入身份证号！'},{validator: this.isCardNo}]}
            ]"
            placeholder='身份证号'
          />
        </a-form-item>
        <a-form-item
          label='层次'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-select
            v-decorator="[
              'level',
              {rules: [{ required: true, message: '请选择层次！' }]}
            ]"
            placeholder='层次'
            @change='levelChange'
          >
            <a-select-option v-for='item in code.code.type2' :key='item.optionId' :value='item.optionId'>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label='专业'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-select
            v-decorator="[
              'profession',
              {rules: [{ required: true, message: '请选择报考专业！'}]}
            ]"
            placeholder='报考专业'
          >
            <a-select-option v-for='item in realProfession' :key='item.professionId' :value='item.professionId'>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label='手机号'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-input
            v-decorator="['phoneNumber',
                          {rules: [{required: true, message: '请输入手机号'},{validator: isPhoneNumber}], validateTrigger: ['change', 'blur']}]" />
        </a-form-item>
        <a-form-item
          type="city"
          label="所在地"
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-cascader :options="options"
                      v-decorator="[
              'city',
              {rules: [{ required: false, message: '请选择！' }]}
            ]" placeholder="请选择"
          />
        </a-form-item>
        <a-form-item
          label='函授站'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-select
            v-decorator="['correspondenceStation', {rules: [{required: false, message: '请选择函授站'}]}]"
            :options='optionList'
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label='志愿'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-select
            allowClear
            v-decorator="[
              'volunteer',
              {rules: [{ required: false, message: '请选择志愿！' }]}
            ]"
            placeholder='志愿'
          >
            <a-select-option value='1'>第一志愿</a-select-option>
            <a-select-option value='2'>第二志愿</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label='备注'
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
        >
          <a-textarea
            v-decorator="['remark', {rules: [{required: false, message: '请输入备注'},{max: 100,message: '最大不能超过100！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot='footer'>
      <a-button key='cancel' @click='handleCancel'>取消</a-button>
      <a-button key='forward' :loading='confirmLoading' type='primary' @click='handleOk'>保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { adultApplyOption, getApplyUserInfoById, adminEditApplyAdult } from '@api/adult/customChannel'
import { getCode } from '@api/adult/customChannel.js'

export default {
  name: 'StationEdit',
  data() {
    return {
      options: [{
        value: '山东省',
        label: '山东省',
        children: [
          { value: '潍坊', label: '潍坊',
            children: [
              {value: '奎文', label: '奎文'},
              {value: '潍城', label: '潍城'},
              {value: '寒亭', label: '寒亭'},
              {value: '坊子', label: '坊子'},
              {value: '青州', label: '青州'},
              {value: '诸城', label: '诸城'},
              {value: '寿光', label: '寿光'},
              {value: '安丘', label: '安丘'},
              {value: '高密', label: '高密'},
              {value: '昌邑', label: '昌邑'},
              {value: '临朐', label: '临朐'},
              {value: '昌乐', label: '昌乐'}
            ]
          },
          { value: '济南', label: '济南' },
          { value: '青岛', label: '青岛' },
          { value: '淄博', label: '淄博' },
          { value: '枣庄', label: '枣庄' },
          { value: '东营', label: '东营' },
          { value: '烟台', label: '烟台' },
          { value: '济宁', label: '济宁' },
          { value: '泰安', label: '泰安' },
          { value: '威海', label: '威海' },
          { value: '日照', label: '日照' },
          { value: '莱芜', label: '莱芜' },
          { value: '临沂', label: '临沂' },
          { value: '德州', label: '德州' },
          { value: '聊城', label: '聊城' },
          { value: '滨州', label: '滨州' },
          { value: '菏泽', label: '菏泽' }
        ]
      }],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      genderList: [
        {
          value: '0',
          label: '男'
        },
        {
          value: '1',
          label: '女'
        }
      ],
      optionList: [],
      code: {
        profession: {},
        code: {}
      },
      realProfession: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      showable: false
    }
  },
  created() {
    this.getOptionList()
    this.getCode()
  },
  methods: {
    // 姓名验证
    isName(rule, value, callback) {
      var reg = /^[\u4E00-\u9FA5]+$/
      if (reg.test(value) === false) {
        callback(new Error('只能输入汉字且不能有空格'))
      }
      callback()
    },
    // 身份证验证
    isCardNo(rule, value, callback) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/
      if (reg.test(value) === false) {
        callback(new Error('身份证输入不合法 或 X请使用大写'))
      }else {
        callback()
      }
    },
    isPhoneNumber(rule, value, callback) {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (reg.test(value) === false) {
        callback(new Error('手机号输入不合法'))
      }
      callback()
    },
    levelChange(value) {
      this.form.resetFields(`profession`, [])
      this.realProfession = []
      if (value === '0') {
        this.realProfession = this.code.profession.level0
      } else if (value === '1') {
        this.realProfession = this.code.profession.level1
      } else {
        this.realProfession = this.code.profession.level2
      }
    },
    // 获取函授站信息
    getOptionList() {
      adultApplyOption().then(res => {
        this.optionList = res.data
      })
    },
    // 获取层次专业
    getCode() {
      getCode().then(res => {
        this.code.profession = res.data.profession
        this.code.code = res.data.code
      })
    },
    // 获取用户信息
    edit(id) {
      this.visible = true
      const { form: { setFieldsValue } } = this
      this.confirmLoading = true
      var record = {}
      getApplyUserInfoById(id).then(res => {
        this.confirmLoading = false
        res.data.city = res.data.studentCity.split("-")
        record = res.data
        this.$nextTick(() => {
          setFieldsValue(pick(res.data, ['id', 'name', 'gender', 'idCard', 'level', 'profession', 'phoneNumber', 'city', 'correspondenceStation','volunteer', 'remark']))
        })
      })
      this.realProfession = []
      if (record.level === '0') {
        this.realProfession = this.code.profession.level0
      } else if (record.level === '1') {
        this.realProfession = this.code.profession.level1
      } else {
        this.realProfession = this.code.profession.level2
      }
    },
    // 结束保存用户信息
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          values.studentCity = values.city.join('-')
          adminEditApplyAdult(values).then(res => {
            if (res.code === 0) {
              this.$message.success(res.msg)
              setTimeout(() => {
                this.$emit('ok')
                this.visible = false
              }, 1500)
            } else {
              this.$message.error(res.msg)
            }
          }).finally(()=>{
            this.confirmLoading = false
          })

        }
      })
    },
    handleCancel() {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    }
  }
}
</script>

<style scoped>

</style>
